var render, staticRenderFns
import script from "./FilePieChart.vue?vue&type=script&lang=js&"
export * from "./FilePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa3f40",
  null
  
)

export default component.exports